import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Tache } from 'src/app/shared/models/tache';
import { ConstantsService } from '../constant/constants.service';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { GenericCrudService } from '../generic-crud.service';

@Injectable({
	providedIn: 'root'
})
export class TacheService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllTache(): Observable<Tache[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.tacheUrl}/all`,
			'getAllTache'
		);
	}

	importTache(file: File): Observable<ImportResponse> {
		const formData: FormData = new FormData();
		formData.append('file', file, 'tache.csv');
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.tacheUrl}/import`,
			`importTache`,
			formData
		);
	}

	getTacheById(id: number): Observable<Tache> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.tacheUrl}/get/${id}`,
			'getTacheById'
		);
	}

	updateTache(tache: Tache): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.tacheUrl}/update/${tache.id}`,
			'updateTache',
			tache
		);
	}

	addTache(tache: Tache): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.tacheUrl}/add`,
			'addTache',
			tache
		);
	}

	deleteTache(tacheId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.tacheUrl}/delete/${tacheId}`,
			`deleteTache`
		);
	}
}
